module.exports = __webpack_public_path__ + "img/proton.ddf0c5af.png";